import { ComponentProps } from 'react';

import Icon from '~/components/scales/Icon/Icon';
import { Tooltip } from '~/components/scales/Tooltip';

type Props = {
  content?: ComponentProps<typeof Tooltip>['content'];
};

export default function Hint(props: Props) {
  if (!props.content) return null;
  return (
    <Tooltip content={props.content}>
      <Icon className="cursor-default" name="help" size="sm" />
    </Tooltip>
  );
}
